var map = {
	"./anm-card.png": 1217,
	"./arrow.png": 1218,
	"./arrow.webp": 1219,
	"./asset-1.svg": 1220,
	"./bg-exclusive.webp": 1221,
	"./boost.svg": 1222,
	"./brand-logo-cny.png": 1223,
	"./brand-logo-raya.webp": 1224,
	"./brand-logo.png": 111,
	"./brand-logo.webp": 1225,
	"./btn-black-m.webp": 1226,
	"./btn-blue-m-v2.png": 1227,
	"./btn-blue-m.png": 1228,
	"./btn-blue-m.webp": 1229,
	"./btn-white-m-v2.png": 1230,
	"./btn-white-m.png": 1231,
	"./check-btn.webp": 1232,
	"./default-bg.webp": 1233,
	"./deposit.webp": 1234,
	"./drop-more-btn.webp": 1235,
	"./duitnow.svg": 1236,
	"./eeziepay.svg": 1237,
	"./fcl.svg": 1238,
	"./fcl.webp": 1239,
	"./fpx-logo.svg": 1240,
	"./game-blue.png": 1241,
	"./game-img.png": 1242,
	"./game-white.png": 1243,
	"./global-language.svg": 1244,
	"./grabpay.svg": 1245,
	"./ifm-logo.svg": 1246,
	"./ifm-logo.webp": 1247,
	"./modal-bg.jpg": 1248,
	"./number-bg.webp": 1249,
	"./pagcor.svg": 1250,
	"./pagcor.webp": 1251,
	"./pool-bg.webp": 1252,
	"./promo-given.webp": 1253,
	"./side-bar-bg.png": 1254,
	"./spotlight-base.svg": 1255,
	"./spotlight.svg": 1256,
	"./tether.svg": 1257,
	"./title-asset.svg": 1258,
	"./tng.svg": 1259,
	"./winner.webp": 1260,
	"./withdrawal.webp": 1261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;